import React, { useState } from 'react';
import Grid from './Grid';
import SettingColumn from '../SettingColumn/SettingColumn';
import { Icons } from '../BootstrapComponents';
import { useStoreState } from '../../../utils/utils';

export default function CustomizedGrid(props) {
  const {
    name,
    columns = [],
    additionalColumns = [],
    settingsFormatter = a => a,
    respectHidden = false,
    withSettingsColumn = true,
  } = props;
  const [isOpen, setOpen] = useState(false);

  const settingsColumn = {
    dataField: 'setting',
    headerFormatter: () => <Icons width={24} height={24} customIcon icon="gear" className="button-icons" />,
    formatter: settingsFormatter,
    disableSort: true,
    headerClassName: 'settings-column align-middle text-center',
    dataClassName: 'settings-column row-full-click align-middle no-avtive',
    onClick: () => () => setOpen(true),
    disablePosition: true,
    disableVisible: true,
  };

  const availableColumns = columns.map((e, i) => ({ ...e, id: `${name}-column-${i}` }));
  const settingsColumnWithId = { ...settingsColumn, id: `${name}-column-${availableColumns.length}` };
  const addColumns = additionalColumns.map((e, i) => ({ ...e, id: `${name}-column-${i + availableColumns.length + (withSettingsColumn ? 1 : 0)}` }));
  const allColumns = [...availableColumns, ...addColumns];
  const allColumnIds = allColumns.map(c => c.id);
  const normalizeColumnsOrder = order => [
    ...order.filter(id => allColumnIds.includes(id)),
    ...allColumnIds.filter(id => !order.includes(id)),
  ];
  const initial = availableColumns.reduce((acc, cur) => { acc[cur.id] = respectHidden ? !cur.hidden : true; return acc; }, {});
  const [visibleColumns, setVisibleColumns, resetVisible, saveVisible] = useStoreState(initial, name);
  const [columnsOrder, setColumnsOrder, resetOrder, saveOrder] = useStoreState(allColumns.map(c => c.id), `${name}-order`);
  const normalizedColumnsOrder = normalizeColumnsOrder(columnsOrder);
  const normalizedVisibleColumns = allColumns.reduce((acc, column) => {
    const hasInitialValue = Object.prototype.hasOwnProperty.call(initial, column.id);

    acc[column.id] = Object.prototype.hasOwnProperty.call(visibleColumns, column.id)
      ? visibleColumns[column.id]
      : (hasInitialValue ? initial[column.id] : false);

    return acc;
  }, {});
  const visibleGridColumns = allColumns
    .filter(c => normalizedVisibleColumns[c.id])
    .sort((a, b) => normalizedColumnsOrder.indexOf(a.id) - normalizedColumnsOrder.indexOf(b.id));
  const gridColumns = withSettingsColumn ? [...visibleGridColumns, settingsColumnWithId] : visibleGridColumns;

  return (
    <>
      <Grid {...props} columns={gridColumns} />
      {withSettingsColumn ? (
        <SettingColumn
          open={isOpen}
          lockOnPopup
          availableColumns={allColumns}
          setVisibleColumns={setVisibleColumns}
          visibleColumns={normalizedVisibleColumns}
          setColumnsOrder={setColumnsOrder}
          columnsOrder={normalizedColumnsOrder}
          resetVisible={resetVisible}
          resetOrder={resetOrder}
          saveVisible={saveVisible}
          saveOrder={saveOrder}
          addColumns={addColumns}
          onHide={() => { setOpen(false); }}
        />
      ) : null}
    </>
  );
}
